import { render, staticRenderFns } from "./RequestTypeEditor.vue?vue&type=template&id=ab862e8c&"
import script from "./RequestTypeEditor.vue?vue&type=script&lang=ts&"
export * from "./RequestTypeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports